import type { IGetActionsData } from "@api";
import CheckIcon from "@mui/icons-material/Check";
import { Tooltip } from "@mui/material";
import { IconButtonVariant, themeBBJ } from "@styleguide";
import { useMemo } from "react";
import { useValidateActionButton } from "./logic";

interface ICheckMarkValidation<
  T extends Pick<
    IGetActionsData,
    "_id" | "status" | "deadlineDate" | "executionDate" | "apply" | "jobSituation" | "type"
  >,
> {
  actions: T[];
  onChange: (actions: T[]) => void;
}

export const CheckMarkValidation = <
  T extends Pick<
    IGetActionsData,
    "_id" | "status" | "deadlineDate" | "executionDate" | "apply" | "jobSituation" | "type"
  >,
>({
  actions,
  onChange,
}: ICheckMarkValidation<T>) => {
  const { tooltipTitle, disableButton, updateActionList } = useValidateActionButton(actions[0]);
  const action = useMemo(() => actions[0], [actions]);

  const handleClick = async () => {
    const updatedActions = await updateActionList(actions, action.deadlineDate || action.executionDate || new Date());
    onChange(updatedActions);
  };

  return (
    <Tooltip title={tooltipTitle}>
      <span>
        <IconButtonVariant
          variant="elevated"
          disabled={disableButton}
          onClick={handleClick}
          sx={(theme) => ({
            border: disableButton
              ? `1px solid ${theme.palette.disabled.main}`
              : `1px solid ${theme.palette.success.main}`,
          })}
        >
          <CheckIcon sx={{ color: disableButton ? themeBBJ.palette.disabled.main : themeBBJ.palette.success.main }} />
        </IconButtonVariant>
      </span>
    </Tooltip>
  );
};
